"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
var react_1 = tslib_1.__importDefault(require("react"));
var TagInput_1 = require("./TagInput");
var TagSearchBox_1 = require("./TagSearchBox");
var i18n_1 = require("../i18n");
var bubble_1 = require("../bubble");
var icon_1 = require("../icon");
var config_context_1 = require("../_util/config-context");
var text_1 = require("../text");
var keys = {
    "8": "backspace",
    "13": "enter",
    "37": "left",
    "38": "up",
    "39": "right",
    "40": "down",
};
var ITag = /** @class */ (function (_super) {
    tslib_1.__extends(ITag, _super);
    function ITag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inEditing: false,
        };
        _this.handleTagClick = function (e, pos) {
            _this.props.dispatchTagEvent("click", pos);
            e.stopPropagation();
        };
        _this.handleDelete = function (e) {
            e.stopPropagation();
            _this.props.dispatchTagEvent("del");
        };
        _this.handleKeyDown = function (e) {
            if (!keys[e.keyCode])
                return;
            e.preventDefault();
            switch (keys[e.keyCode]) {
                case "tab":
                case "enter":
                    _this.props.dispatchTagEvent("click", "value");
                    break;
                case "backspace":
                    _this.props.dispatchTagEvent("del", "keyboard");
                    break;
            }
        };
        return _this;
    }
    ITag.prototype.focusTag = function () {
        var _a;
        (_a = this["input-inside"]) === null || _a === void 0 ? void 0 : _a.focusInput();
    };
    ITag.prototype.focusInput = function () {
        var _a;
        (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.focusInput();
    };
    ITag.prototype.resetInput = function () {
        var _a;
        (_a = this["input-inside"]) === null || _a === void 0 ? void 0 : _a.resetInput();
    };
    ITag.prototype.setInputValue = function (value, callback) {
        var _a;
        (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.setInputValue(value, callback);
    };
    ITag.prototype.getInputValue = function () {
        var _a;
        return (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.getInputValue();
    };
    ITag.prototype.addTagByInputValue = function () {
        var _a;
        return (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.addTagByInputValue();
    };
    ITag.prototype.addTagByEditInputValue = function () {
        var _a;
        if (!this["input-inside"])
            return;
        return (_a = this["input-inside"]) === null || _a === void 0 ? void 0 : _a.addTagByInputValue();
    };
    ITag.prototype.setInfo = function (info, callback) {
        var _a;
        return (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.setInfo(info, callback);
    };
    ITag.prototype.moveToEnd = function () {
        var _a;
        return (_a = this["input"]) === null || _a === void 0 ? void 0 : _a.moveToEnd();
    };
    ITag.prototype.getInfo = function () {
        var _a = this.props, attr = _a.attr, values = _a.values;
        return { attr: attr, values: values };
    };
    ITag.prototype.edit = function (pos) {
        this.setState({ inEditing: true });
        var input = this["input-inside"];
        input === null || input === void 0 ? void 0 : input.setInfo(this.getInfo(), function () {
            if (pos === "attr") {
                return input.selectAttr();
            }
            return input.selectValue();
        });
    };
    ITag.prototype.editDone = function () {
        this.setState({ inEditing: false });
    };
    ITag.prototype.render = function () {
        var _this = this;
        var inEditing = this.state.inEditing;
        var _a = this.props, t = _a.t, classPrefix = _a.config.classPrefix, active = _a.active, attr = _a.attr, values = _a.values, dispatchTagEvent = _a.dispatchTagEvent, attributes = _a.attributes, focused = _a.focused, maxWidth = _a.maxWidth;
        var attrStr = attr ? attr.name : "";
        if (attr && attr.name) {
            attrStr += ": ";
        }
        var valueStr = values.map(function (item) { return item.name; }).join(" | ");
        var removeable = attr && "removeable" in attr ? attr.removeable : true;
        return (react_1.default.createElement("div", { style: {
                display: "inline-block",
                minHeight: 20,
                width: inEditing && !active ? 0 : "auto",
                position: "relative",
                verticalAlign: "inherit",
            } },
            react_1.default.createElement(bubble_1.Bubble, { content: active ? t.tagSearchBoxEditingTips : null },
                react_1.default.createElement("div", { className: classPrefix + "-tag", ref: function (div) { return (_this["content"] = div); }, style: {
                        display: inEditing ? "none" : undefined,
                        paddingRight: removeable ? undefined : 8,
                    }, onClick: this.handleTagClick },
                    react_1.default.createElement(text_1.Text, { parent: "span", theme: "label", onClick: function (e) { return _this.handleTagClick(e, "attr"); } }, attrStr),
                    react_1.default.createElement("span", { onClick: function (e) { return _this.handleTagClick(e, "value"); } }, valueStr),
                    active && removeable && (react_1.default.createElement(icon_1.Icon, { type: "dismiss", onClick: this.handleDelete })))),
            react_1.default.createElement(TagInput_1.TagInput, { type: "edit", hidden: !inEditing, maxWidth: maxWidth, handleKeyDown: this.handleKeyDown, active: active, ref: function (input) { return (_this["input-inside"] = input); }, attributes: attributes, dispatchTagEvent: dispatchTagEvent, isFocused: focused === TagSearchBox_1.FocusPosType.INPUT_EDIT })));
    };
    return ITag;
}(react_1.default.Component));
exports.Tag = config_context_1.withConfig(i18n_1.withTranslation(ITag));
//# sourceMappingURL=Tag.js.map